// import type React from "react"
import { useState, useRef, useEffect } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { apiCall } from "../utils/apiService";

const ChatSystem = () => {
    const messagesEndRef = useRef(null)
    const [users, setUsers] = useState([])

    const [totalParticipants, setTotalParticipants] = useState(null)
    const [selectedUser, setSelectedUser] = useState(null)
    const [messages, setMessages] = useState([])

    const [selectedChannel, setSelectedChannel] = useState("")
    const [newMessage, setNewMessage] = useState("")
    const [searchTerm, setSearchTerm] = useState("")
    const [sidebarOpen, setSidebarOpen] = useState(true)

    // Voice recording states
    const [isRecording, setIsRecording] = useState(false)
    const [recordingDuration, setRecordingDuration] = useState(0)
    const [audioBlob, setAudioBlob] = useState(null)
    const mediaRecorderRef = useRef(null)
    const audioChunks = useRef([])
    const timerIntervalRef = useRef(null)
    const [filteredUsers, setFilteredUsers] = useState(users);

    // const handleSendMessage = async (msg_type) => {
    //     if (!selectedUser) return
    //     if (msg_type === "text" && newMessage.trim() === "") return

    //     // Construct the base message object
    //     const message = {
    //         type: selectedUser.type,
    //         chat_id: selectedUser.id,
    //         sender: "user",
    //         timestamp: new Date(),
    //         read: false,
    //         recipient_id: selectedUser.sid,
    //         msg_type: msg_type,
    //     }

    //     if (msg_type === "text") {
    //         // For text messages, include the message text
    //         message.content = newMessage
    //         message.text = newMessage
    //     } else if (msg_type === "attachment" && audioBlob) {
    //         // For audio messages, include the audio Blob or URL
    //         const ab = URL.createObjectURL(audioBlob)
    //         message.content = ab
    //         message.text = ab
    //     }

    //     try {
    //         const response = await apiCall({
    //             url: `social/send-message`,
    //             method: "POST",
    //             body: message,
    //         })

    //         if (response.success) {
    //             // Clear the input field for text messages
    //             if (msg_type === "text") {
    //                 setNewMessage("")
    //             }

    //             // Reset audio blob after sending
    //             if (msg_type === "attachment") {
    //                 setAudioBlob(null)
    //             }

    //             // Update last message in user list
    //             setUsers(
    //                 users.map((user) =>
    //                     user.id === selectedUser?.id
    //                         ? {
    //                             ...user,
    //                             lastMessage: msg_type === "text" ? newMessage : "Audio message",
    //                             lastMessageTime: new Date(),
    //                         }
    //                         : user,
    //                 ),
    //             )

    //             // Scroll to the bottom of the chat
    //             if (messagesEndRef.current) {
    //                 messagesEndRef.current.scrollIntoView({ behavior: "smooth" })
    //             }

    //             // Add the message to the messages list
    //             setMessages((prevMessages) => [...prevMessages, message])
    //         }
    //     } catch (error) {
    //         console.log(error.message)
    //     }
    // }

    const handleSendMessage = async (msg_type) => {
        if (!selectedUser) return;
        if (msg_type === "text" && newMessage.trim() === "") return;

        // Construct the base message object
        const message = {
            type: selectedUser.type,
            chat_id: selectedUser.id,
            sender: "user",
            timestamp: new Date(),
            read: false,
            recipient_id: selectedUser.sid,
            msg_type: msg_type,
        };

        // Prepare FormData
        const formData = new FormData();

        try {
            if (msg_type === "text") {
                // For text messages, include the message text in the FormData
                formData.append("type", selectedUser.type);
                formData.append("chat_id", selectedUser.id);
                formData.append("sender", "user");
                formData.append("timestamp", new Date().toISOString()); // Use ISO string for timestamp
                formData.append("read", false);
                formData.append("recipient_id", selectedUser.sid);
                formData.append("msg_type", msg_type);
                formData.append("content", newMessage);
                formData.append("text", newMessage);
                message.content = newMessage;
                message.text = newMessage;
            } else if (msg_type === "attachment" && audioBlob) {
                // For audio messages, convert Blob to File and include it in the form data
                const file = new File([audioBlob], "audio_message.mp3", {
                    type: "audio/mp3", // Use appropriate MIME type for your audio
                });

                // Append file and message content to the FormData
                formData.append("file", file);
                formData.append("type", selectedUser.type);
                formData.append("chat_id", selectedUser.id);
                formData.append("sender", "user");
                formData.append("timestamp", new Date().toISOString()); // Use ISO string for timestamp
                formData.append("read", false);
                formData.append("recipient_id", selectedUser.sid);
                formData.append("msg_type", msg_type);
                const ab = URL.createObjectURL(audioBlob); // URL for the audio file
                formData.append("content", ab); // Add audio URL as content
                formData.append("text", ab); // Optionally add description of the file
                message.content = ab;
                message.text = ab;
            }

            // Send the FormData with all the data (message and file)
            const response = await apiCall({
                url: `social/send-message`, // Same API for sending message
                method: "POST",
                body: formData,
                withoutStringify: true
            });

            if (response.success) {
                // Clear the input field for text messages
                if (msg_type === "text") {
                    setNewMessage("");
                }

                // Reset audio blob after sending
                if (msg_type === "attachment") {
                    setAudioBlob(null);
                }

                // Update last message in user list
                setFilteredUsers(
                    users.map((user) =>
                        user.id === selectedUser?.id
                            ? {
                                ...user,
                                lastMessage: msg_type === "text" ? newMessage : "Audio message",
                                lastMessageTime: new Date(),
                            }
                            : user,
                    ),
                );

                // Scroll to the bottom of the chat
                if (messagesEndRef.current) {
                    messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
                }

                // Add the message to the messages list
                // setMessages((prevMessages) => [...prevMessages, message]);
            }
        } catch (error) {
            console.log(error.message);
        }
    };


    const selectUser = (user) => {
        user.unreadCount = 0;
        getConversationMessages(user.id)
        setSelectedUser(user)
        // Mark messages as read
        setUsers(users.map((u) => (u.id === user.id ? { ...u, unreadCount: undefined } : u)))
    }

    const formatTime = (date) => {
        date = new Date(date)
        return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
    }

    const formatDate = (date) => {
        date = new Date(date)
        const today = new Date()
        const yesterday = new Date(today)
        yesterday.setDate(yesterday.getDate() - 1)

        if (date.toDateString() === today.toDateString()) {
            return formatTime(date)
        } else if (date.toDateString() === yesterday.toDateString()) {
            return "Yesterday"
        } else {
            return date.toLocaleDateString([], {
                month: "short",
                day: "numeric",
            })
        }
    }

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen)
    }

    const getConversationList = async () => {
        try {
            const response = await apiCall({
                url: `social/get-conversation-list`,
                method: "GET",
            })
            if (response.data.conversations.length > 0) {

                setUsers(response.data.conversations)
                if (response.data.conversations.length > 0) {
                    getConversationMessages(response.data.conversations[0].id)
                    response.data.conversations[0].unreadCount = 0;
                    setSelectedUser(response.data.conversations[0]);
                }
                setFilteredUsers(response.data.conversations)
                setTotalParticipants(response.data.conversations.length)
            }
        } catch (error) {
            console.error("Error fetching conversations:", error)
        }
    }

    const getConversationMessages = async (chatId) => {
        try {
            const response = await apiCall({
                url: `social/get-conversation-messages?chat_id=${chatId}`,
                method: "GET",
            })
            if (response) {
                setMessages(response.data || [])
            }
        } catch (error) {
            console.error("Error fetching messages:", error)
        }
    }

    // Format recording duration as MM:SS
    const formatDuration = (seconds) => {
        const mins = Math.floor(seconds / 60)
        const secs = seconds % 60
        return `${mins.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`
    }

    // Start recording
    const handleStartRecording = () => {
        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
            navigator.mediaDevices
                .getUserMedia({ audio: true })
                .then((stream) => {
                    mediaRecorderRef.current = new MediaRecorder(stream)
                    audioChunks.current = []

                    mediaRecorderRef.current.ondataavailable = (e) => {
                        audioChunks.current.push(e.data)
                    }

                    mediaRecorderRef.current.onstop = () => {
                        const audioBlobData = new Blob(audioChunks.current, { type: "audio/wav" })
                        setAudioBlob(audioBlobData)
                    }

                    mediaRecorderRef.current.start()
                    setIsRecording(true)

                    // Start timer
                    setRecordingDuration(0)
                    timerIntervalRef.current = setInterval(() => {
                        setRecordingDuration((prev) => prev + 1)
                    }, 1000)
                })
                .catch((error) => {
                    console.error("Error accessing microphone: ", error)
                })
        }
    }

    // Stop recording
    const handleStopRecording = () => {
        if (mediaRecorderRef.current && mediaRecorderRef.current.state !== "inactive") {
            mediaRecorderRef.current.stop()

            // Stop all tracks in the stream
            if (mediaRecorderRef.current.stream) {
                mediaRecorderRef.current.stream.getTracks().forEach((track) => track.stop())
            }

            // Clear timer
            clearInterval(timerIntervalRef.current)
            setIsRecording(false)
        }
    }

    // Cancel recording
    const handleCancelRecording = () => {
        if (mediaRecorderRef.current && mediaRecorderRef.current.state !== "inactive") {
            mediaRecorderRef.current.stop()

            // Stop all tracks in the stream
            if (mediaRecorderRef.current.stream) {
                mediaRecorderRef.current.stream.getTracks().forEach((track) => track.stop())
            }

            // Clear timer and reset states
            clearInterval(timerIntervalRef.current)
            setIsRecording(false)
            setAudioBlob(null)
            audioChunks.current = []
        }
    }

    // Send recorded audio
    const handleSendRecording = () => {
        if (audioBlob) {
            handleSendMessage("attachment")
        }
    }

    const handleSearch = (e) => {
        const term = e.target.value;
        setSearchTerm(term);
        let filteredUsers = users.filter((user) => user.name.toLowerCase().includes(term.toLowerCase()))
        setTotalParticipants(filteredUsers.length)
        setFilteredUsers(filteredUsers);
    };

    const filterByChannel = (val) => {
        setSelectedChannel(val)
        let filteredUsers = null;
        if (val == 'unread') {
            filteredUsers = users.filter((user) => user.unreadCount !== 0)
        } else {
            filteredUsers = users.filter((user) => user.type === val || val === 'all')
        }
        setTotalParticipants(filteredUsers.length)
        setFilteredUsers(filteredUsers);
    }

    // Use a ref to store the latest selectedUser value
    const selectedUserRef = useRef(selectedUser);
    const usersRef = useRef(filteredUsers);

    // Update the ref value whenever selectedUser changes
    useEffect(() => {
        selectedUserRef.current = selectedUser;
        usersRef.current = filteredUsers;
    }, [selectedUser, filteredUsers]);

    useEffect(() => {
        document.title = "Social Chat"

        getConversationList();

        // Connect to WebSocket server
        // const socket = new WebSocket('wss://wap.alphaxcloud.com:8001');  // WebSocket URL should match your backend server
        const socket = new WebSocket('wss://meta.sabtech.org/:8010');  // WebSocket URL should match your backend server
        // const socket = new WebSocket('ws://localhost:8000');  // WebSocket URL should match your backend server

        let pingInterval;

        // Listen for messages from the backend
        socket.onmessage = (event) => {
            let sUser = selectedUserRef.current;
            let us = usersRef.current;
            let eventData = JSON.parse(event.data);

            if (eventData?.sid == sUser?.sid) {
                console.log('Message from backend:', eventData.sid);
                setMessages(prevMessages => [
                    ...prevMessages,
                    eventData
                ]);
            }

            // Update the users list and sort it based on lastMessageTime (for example, descending)
            const updatedUsers = us.map((user) => user?.sid === eventData?.sid
                ? {
                    ...user,
                    lastMessage: eventData.text,
                    lastMessageTime: new Date(),
                    unreadCount: eventData?.is_read ? user.unreadCount : user.unreadCount + 1
                }
                : user
            );

            // Set the sorted users list
            setFilteredUsers(updatedUsers);
        };

        socket.onopen = () => {
            console.log('Connected to WebSocket server');

            // Set up the ping interval
            pingInterval = setInterval(() => {
                // Send a ping message (you can use any kind of message, depending on your server's requirements)
                socket.send(JSON.stringify({ type: 'ping' }));
            }, 30000); // 30 seconds
        };

        socket.onclose = () => {
            console.log('WebSocket connection closed');
        };

        return () => {
            clearInterval(pingInterval);  // Clean up ping interval
            if (socket.readyState === WebSocket.OPEN) {
                socket.close();  // Close WebSocket connection on cleanup
            }
            // Clean up recording if component unmounts while recording
            if (isRecording) {
                clearInterval(timerIntervalRef.current)
                if (mediaRecorderRef.current && mediaRecorderRef.current.state !== "inactive") {
                    mediaRecorderRef.current.stop()
                    if (mediaRecorderRef.current.stream) {
                        mediaRecorderRef.current.stream.getTracks().forEach((track) => track.stop())
                    }
                }
            }
        }
    }, [])

    return (
        <div className="d-flex h-100 bg-light">
            {/* Left Sidebar - User List */}
            <div
                className={`${sidebarOpen ? "d-block" : "d-none"} d-md-block bg-white border-end border-gray-200 d-flex flex-column shadow-sm`}
                style={{ width: "20%", height: "73vh", fontSize: '14px' }}
            >
                <div className="p-3 border-bottom border-gray-200">
                    <div className="d-flex justify-content-between">
                        <span className="text-dark" style={{ fontWeight: 'bold' }}>Participants</span>
                        <span className="text-dark" style={{ fontWeight: 'bold' }}>({totalParticipants})</span>
                    </div>
                    <select name="" id="" className="form-select my-2" style={{ fontSize: '14px' }} value={selectedChannel} onChange={(e) => filterByChannel(e.target.value)}>
                        <option value="" selected disabled>Select Channel</option>
                        <option value="all">Select All</option>
                        <option value="whatsapp">Whatsapp</option>
                        <option value="facebook">Facebook</option>
                        <option value="instagram">Instagram</option>
                        <option value="unread">Unread</option>
                    </select>
                    <div className="mt-2 position-relative">
                        <input
                            type="text"
                            placeholder="Search contacts..."
                            className="w-100 ps-5 border rounded focus:outline-none focus:ring-2 focus:ring-success shadow-sm"
                            style={{ padding: "10px 20px" }}
                            value={searchTerm}
                            onChange={handleSearch}
                        />
                        <Icon
                            icon="mdi-magnify"
                            className="menu-icon fs-4 position-absolute top-50 start-0 ms-3 text-muted translate-middle-y"
                        />
                    </div>
                </div>
                <div
                    className="overflow-auto flex-grow-1 pb-5"
                    style={{ height: "60vh", scrollbarWidth: "none", msOverflowStyle: "none", paddingBottom: "25px" }}
                >
                    {filteredUsers
                        .sort((a, b) => new Date(b.lastMessageTime) - new Date(a.lastMessageTime))
                        .map((user, index) => (
                            <div
                                key={user.id}
                                className={`px-3 py-10 border-bottom border-gray-100 cursor-pointer d-flex align-items-center ${selectedUser?.id === user.id ? "bg-light" : ""}`}
                                onClick={() => selectUser(user)}
                                style={{ cursor: "pointer" }}
                            >
                                <div className="position-relative">
                                    <div
                                        className={`rounded-circle d-flex align-items-center justify-content-center text-white font-semibold ${user.type === "facebook" ? "bg-success-main" : user.type === "instagram" ? "bg-danger" : "bg-success-main"
                                            }`}
                                        style={{ width: "40px", height: "40px" }}
                                    >
                                        {user.type === "instagram" && (
                                            <Icon icon="logos:instagram-icon" style={{ width: "30px", height: "30px" }} />
                                        )}
                                        {user.type === "facebook" && <Icon icon="bi:chat-dots" style={{ width: "30px", height: "30px" }} />}
                                        {user.type === "whatsapp" && (
                                            <Icon icon="logos:whatsapp-icon" style={{ width: "30px", height: "30px" }} />
                                        )}
                                    </div>
                                    <span
                                        className={`position-absolute bottom-0 end-0 border-2 border-white rounded-circle ${user.type === "facebook"
                                            ? "bg-success-main"
                                            : user.type === "instagram"
                                                ? "bg-warning"
                                                : "bg-secondary"
                                            }`}
                                        style={{ width: "12px", height: "12px" }}
                                    ></span>
                                </div>
                                <div className="ms-3 flex-grow-1 overflow-hidden">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <p className="text-dark" style={{ fontSize: '14px', margin: '0px', fontWeight: 'bold' }}>{user.name}</p>
                                        <span className="text-muted small">{formatDate(user.lastMessageTime)}</span>
                                    </div>
                                    <div className="d-flex justify-content-between align-items-center gap-2">
                                        <p className="text-muted text-truncate small m-0">{user.lastMessage}</p>
                                        {
                                            user.unreadCount > 0 && (
                                                <p className={`d-flex justify-content-center align-items-center text-white text-truncate small m-0 rounded-circle ${user.type === "facebook" ? "bg-success-main" : user.type === "instagram" ? "bg-danger" : "bg-success-main"}`}
                                                    style={{
                                                        fontSize: '14px',
                                                        width: '25px',
                                                        height: '25px',
                                                        lineHeight: '25px',
                                                        textAlign: 'center',
                                                        padding: '12px'
                                                    }}>
                                                    {user.unreadCount}
                                                </p>
                                            )
                                        }
                                    </div>
                                </div>
                            </div>
                        ))}
                </div>
            </div>

            {/* Right Side - Chat Area */}
            <div className="flex-grow-1 d-flex flex-column">
                {/* Chat Header */}
                <div className="bg-white p-4 border-bottom border-gray-200 d-flex justify-content-between align-items-center shadow-sm">
                    <div className="d-flex align-items-center p-2">
                        <button className="d-md-none me-3 fs-2 text-muted" onClick={toggleSidebar}>
                            <Icon icon="mdi-menu" />
                        </button>
                        {selectedUser && (
                            <>
                                <div className="position-relative">
                                    <div
                                        className={`rounded-circle d-flex align-items-center justify-content-center text-white font-semibold ${selectedUser.type === "facebook"
                                            ? "bg-success-main"
                                            : selectedUser.type === "instagram"
                                                ? "bg-danger"
                                                : "bg-success-main"
                                            }`}
                                        style={{ width: "40px", height: "40px" }}
                                    >
                                        {selectedUser.avatar || selectedUser?.name?.charAt(0)}
                                    </div>
                                    <span
                                        className={`position-absolute bottom-0 end-0 border-2 border-white rounded-circle ${selectedUser.type === "online"
                                            ? "bg-success-main"
                                            : selectedUser.type === "instagram"
                                                ? "bg-warning"
                                                : "bg-secondary"
                                            }`}
                                        style={{ width: "12px", height: "12px" }}
                                    ></span>
                                </div>
                                <div className="ms-3 p-2">
                                    <h6 className="text-dark fs-6">{selectedUser.name}</h6>
                                    <p className="text-muted small m-0">{selectedUser.type}</p>
                                </div>
                            </>
                        )}
                    </div>
                    <div className="d-flex align-items-center gap-3">
                        <button className="text-muted">
                            <Icon icon="mdi-phone" className="fs-4" />
                        </button>
                        <button className="text-muted">
                            <Icon icon="mdi-video" className="fs-4" />
                        </button>
                        <button className="text-muted">
                            <Icon icon="mdi-dots-vertical" className="fs-4" />
                        </button>
                    </div>
                </div>

                {/* Chat Messages */}
                <div
                    className="flex-grow-1 p-4 bg-light"
                    style={{ overflowY: "auto", height: "0vh", scrollbarWidth: "none", msOverflowStyle: "none" }}
                >
                    {messages.length > 0 && messages.map((message, index) => (
                        <div
                            key={message.id || index}
                            className={`d-flex mb-4 ${message.sender === "user" ? "justify-content-end" : "justify-content-start"}`}
                        >
                            {message.sender === "other" && (
                                <div
                                    style={{ width: "40px", height: "40px" }}
                                    className="rounded-circle bg-success-main d-flex align-items-center justify-content-center text-white text-xs me-2"
                                >
                                    {selectedUser?.avatar || selectedUser?.name?.charAt(0)}
                                </div>
                            )}
                            <div
                                className={`rounded-lg p-3 ${message.sender === "user" ? "bg-success-main text-white rounded" : "bg-white text-dark rounded shadow-sm"
                                    }`}
                            >
                                {/* Display Text Messages */}
                                {message.msg_type !== "attachment" && <p className="small">{message.text}</p>}

                                {/* Display Audio Messages */}
                                {message.msg_type === "attachment" && message.text && (
                                    <div className="audio-message" style={{ width: "250px" }}>
                                        <audio controls className="w-100">
                                            <source src={message.text} type="audio/wav" />
                                            Your browser does not support the audio element.
                                        </audio>
                                    </div>
                                )}

                                <div
                                    className={`d-flex justify-content-end align-items-center mt-1 text-xs ${message.sender === "user" ? "text-light" : "text-dark"
                                        }`}
                                >
                                    {formatTime(message.timestamp)}
                                    {message.sender === "user" && <span className="ms-1">{message.read ? "✓✓" : "✓"}</span>}
                                </div>
                            </div>
                            {message.sender === "user" && (
                                <div
                                    style={{ width: "40px", height: "40px" }}
                                    className="rounded-circle bg-warning d-flex align-items-center justify-content-center text-light text-xs ms-2"
                                >
                                    You
                                </div>
                            )}
                        </div>
                    ))}
                    <div ref={messagesEndRef} />
                </div>

                {/* Chat Input */}
                <div className="p-3 bg-white border-top border-gray-200 shadow-sm">
                    {!isRecording ? (
                        // Normal Input Mode
                        <div className="d-flex align-items-center">
                            <input
                                type="text"
                                value={newMessage}
                                onChange={(e) => setNewMessage(e.target.value)}
                                onKeyPress={(e) => e.key === "Enter" && handleSendMessage("text")}
                                className="flex-grow-1 border rounded-start py-3 px-4"
                                placeholder="Type your message..."
                            />

                            {/* Send Text Message Button */}
                            <button
                                onClick={() => handleSendMessage("text")}
                                className="bg-success-main text-white rounded-end px-3 py-3"
                                disabled={!newMessage.trim()}
                            >
                                <Icon icon="bi:send" />
                            </button>

                            {/* Microphone Button */}
                            <button
                                onClick={handleStartRecording}
                                className="bg-secondary text-white rounded-circle ms-2 d-flex align-items-center justify-content-center"
                                style={{ width: "46px", height: "46px" }}
                            >
                                <Icon icon="bi:mic" />
                            </button>
                        </div>
                    ) : (
                        // Recording Mode - Simplified
                        <div className="d-flex align-items-center bg-light rounded p-3">
                            <div className="d-flex align-items-center flex-grow-1">
                                <div className="me-3 d-flex align-items-center">
                                    <div className="bg-danger rounded-circle me-2" style={{ width: "12px", height: "12px" }}></div>
                                    <span className="text-danger fw-bold">Recording {formatDuration(recordingDuration)}</span>
                                </div>
                            </div>

                            {/* Recording Controls */}
                            <div className="d-flex ms-3">
                                {/* Cancel Button */}
                                <button onClick={handleCancelRecording} className="btn btn-outline-danger me-2">
                                    <Icon icon="bi:x-lg" />
                                </button>

                                {/* Stop and Send Button */}
                                <button onClick={handleStopRecording} className="btn btn-success">
                                    <Icon icon="bi:check-lg" />
                                </button>
                            </div>
                        </div>
                    )}

                    {/* Audio Preview (if recording is stopped but not sent) */}
                    {!isRecording && audioBlob && (
                        <div className="mt-2 p-2 bg-light rounded d-flex align-items-center">
                            <audio controls className="flex-grow-1 me-2" style={{ height: "40px" }}>
                                <source src={URL.createObjectURL(audioBlob)} type="audio/wav" />
                            </audio>
                            <div className="d-flex">
                                <button onClick={() => setAudioBlob(null)} className="btn btn-outline-danger me-2">
                                    <Icon icon="bi:trash" />
                                </button>
                                <button onClick={handleSendRecording} className="btn btn-success">
                                    <Icon icon="bi:send" />
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default ChatSystem

